
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Policy = ({ t }) => {
    const privacy = t('common:privacy', {}, { returnObjects: true });
    return (<div className='policy_section'>
            <div className='container'>
                <div className='policy_section_wrapper'>
                    <h1 className=''>{privacy.title}</h1>
                    {privacy.data.map((item, i) => {
            return (<div className="policy_section_item" key={i}>
                                {item.title ? <h4>{item.title}</h4> : null}
                                {item.sub_title ? <h6>{item.sub_title}</h6> : null}
                                {item.sub_title_2 ? <h6>{item.sub_title}</h6> : null}
                                {item.items ? item.items.map((el, i) => {
                    return (<p className='main_text_style' key={i}>{el}</p>);
                }) : null}
                            </div>);
        })}
                </div>
            </div>
        </div>);
};
export default Policy;

    async function __Next_Translate__getStaticProps__192c28629d6__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//policy/Policy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__192c28629d6__ as getStaticProps }
  